/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { withLoadingAsync, showToast, showModal } from '../../services/common-service'
import styles from './styles.module.scss';
import { getAllContextData, deleteAllVariables, deleteVariable } from '../../services/context-service'
import { getContact } from '../../services/contact-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'
import SimpleEditor from '../../components/SimpleEditor';
import sherlock from '../../assets/images/sherlock.png'

const Contact = () => {
    const [contactIdentity, setContactIdentity] = useState("");
    const [contextVariablesData, setContextVariablesData] = useState([]);
    const [selectedVariable, setSelectedVariable] = useState({});
    const [isEditable, setIsEditable] = useState(false);
    const [editorContextValue, setEditorContextValue] = useState("")
    const [editorContactValue, setEditorContactValue] = useState("")
    const [isValidContact, setIsValidContact] = useState(null);
    const [tabSelected, setTabSelected] = useState("contact");

    useEffect(() => {
        getAppDataAsync();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // eslint-disable-next-line
    }, [contextVariablesData])

    const getAppDataAsync = async () => {
    };

    const SearchUser = async () => {
        const contactResponse = await getContact(contactIdentity)
        console.log(contactResponse)
        if (contactResponse.identity){
            setIsValidContact(true)
            setEditorContactValue(JSON.stringify(contactResponse))
        }
        else{
            setIsValidContact(false)
        }
    }

    const LoadUserContext = async () => {
        const allContextVariables = await getAllContextData(contactIdentity)
        console.log(contactIdentity)
        console.log(allContextVariables)
        setContextVariablesData(allContextVariables)
    }

    const handleDeleteVariable = async (variable) => {
        const { response } = await showModal(
            'Atenção',
            'Tem certeza que deseja excluir a variável?'
        );
        if (response) {
            DeleteUserContext(variable)
        }
    }

    const handleDeleteAllVariables = async () => {
        const { response } = await showModal(
            'Atenção',
            'Tem certeza que deseja excluir todas variáveis desse contato?'
        );
        if (response) {
            DeleteAllUserContext()
        }
    }

    const DeleteUserContext = async (variable) => {
        withLoadingAsync(async () => {
            await deleteVariable(contactIdentity, variable)
            await LoadUserContext()
        })
        showToast(BlipPortalToastTypes.SUCCESS, 'Variável excluída com sucesso');
    }

    const DeleteAllUserContext = async (variable) => {
        withLoadingAsync(async () => {
            await deleteAllVariables(contactIdentity)
            await LoadUserContext()
        })
        showToast(BlipPortalToastTypes.SUCCESS, 'Variáveis excluídas com sucesso');
    }

    const isJson = (str) =>  {
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
      }

    return (
        <>
            <div className="ph1 ph4-m ph5-ns mt2">
                <div className="flex justify-start mb2">
                    <div className="flex justify-start w-30">
                        <div className="items-center pt3">
                            <bds-typo variant="fs-24" >
                                Contato e Contexto
                            </bds-typo>
                        </div>
                    </div>
                    <div className="flex justify-start items-center w-30">
                        <bds-input
                            label="Busca Contato"
                            id="Busca Contato"
                            value=""
                            onInput={(e) => {
                                setContactIdentity(e.target.value)
                            }}
                        />
                        <div className="ml2">
                            <bds-button-icon
                                variant="secondary"
                                size="standard"
                                icon="search"
                                onClick={() => {
                                    withLoadingAsync(async () => {
                                        await SearchUser()
                                        await LoadUserContext()
                                        if (isValidContact){
                                            setTabSelected("contact")
                                        }
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="flex justify-end items-center w-40">
                        <div className="ml2">
                            <bds-button-group color="primary"direction="row" size="medium">
                                <bds-button
                                    icon-left="contact"
                                    color={tabSelected === "contact" ? "primary" : "secondary"}
                                    onClick={() => {
                                        setTabSelected("contact")
                                    }}
                                />
                                <bds-button
                                    icon-left="code"
                                    color={tabSelected === "context" ? "primary" : "secondary"}
                                    onClick={() => {
                                        setTabSelected("context")
                                    }}
                                />
                            </bds-button-group>
                        </div>
                        <div className="ml2">
                            <bds-button
                                variant="outline"
                                color="primary"
                                size="standard"
                                icon-left="refresh"
                                onClick={() => {
                                    withLoadingAsync(async () => {
                                        await LoadUserContext()
                                    })
                                }}
                            />
                        </div>
                        <div className="ml2">
                            <bds-button
                                variant="outline"
                                color="negative"
                                size="standard"
                                icon-left="trash"
                                disabled={false}
                                onClick={() => {
                                    handleDeleteAllVariables()
                                }}
                            />
                        </div>
                    </div>
                </div>
                {isValidContact === null &&
                    <div className="mt5">
                        <div className='flex justify-center'>
                            <img className="w-10" src={sherlock} alt="sherlock" />
                        </div>
                        <div className='flex justify-center'>
                            <h2 style={{ color: "#6E7B91" }}>
                                Busque um contato para conferiar as variaveis!
                            </h2>
                        </div>
                    </div>
                }
                {isValidContact === false &&
                    <div className="mt5">
                        <div className='flex justify-center'>
                            <img className="w-10" src={sherlock} alt="sherlock" />
                        </div>
                        <div className='flex justify-center'>
                            <h2 style={{ color: "#6E7B91" }}>
                                O contato que voê pesquisou não foi encontrado!
                            </h2>
                        </div>
                    </div>
                }
                {isValidContact === true &&
                    <div className="flex">
                        <div className='w-30'>
                            <div className={styles['variable-list']}>
                                <bds-paper elevation="static">
                                    {contextVariablesData?.map((item, index) => (
                                        <div className="flex justify-between items-center">
                                                <div
                                                    className='pointer ml3 w-100'
                                                    onClick={() => {
                                                        setSelectedVariable(item)
                                                        setEditorContextValue(item.value)
                                                        setIsEditable(false)
                                                        console.log(selectedVariable)
                                                    }}
                                                >
                                                    <bds-typo variant="fs-16" id={"texto " + index}>
                                                        {item.name}
                                                    </bds-typo>
                                                </div>
                                            <div className="flex justify-end items-center">
                                                <div className='mr1'>
                                                    <bds-button-icon
                                                        icon="edit"
                                                        id={"open " +index}
                                                        variant="secondary"
                                                        size="short"
                                                        onClick={() => {
                                                            setSelectedVariable(item)
                                                            setEditorContextValue(item.value)
                                                            setIsEditable(true)
                                                            console.log(selectedVariable)
                                                        }}
                                                    />
                                                </div>
                                                <div className=''>
                                                    <bds-button-icon
                                                        icon="trash"
                                                        id={"delete " +index}
                                                        variant="secondary"
                                                        size="short"
                                                        onClick={() => {
                                                            handleDeleteVariable(item.name)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </bds-paper>
                            </div>
                        </div>
                        <div className='w-70'>
                            <bds-paper elevation="static">
                                {tabSelected === "contact" &&
                                    <SimpleEditor
                                        editable={true}
                                        value={isJson(editorContactValue) ? JSON.stringify(JSON.parse(editorContactValue), null, 2) : editorContactValue}
                                        onChange={(newValue) => setEditorContactValue(newValue)}
                                    />
                                }
                                {tabSelected === "context" &&
                                    <SimpleEditor
                                        editable={isEditable}
                                        value={isJson(editorContextValue) ? JSON.stringify(JSON.parse(editorContextValue), null, 2) : editorContextValue}
                                        onChange={(newValue) => setEditorContextValue(newValue)}
                                    />
                                }
                            </bds-paper>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default Contact
